const emailDesigner = {
  searchTemplates: "Search templates...",
  allCategories: "All categories",
  newTemplate: "New template",
  templates: "Templates",
  noTemplates: "No templates",
  selectOrCreate: "Select a template or create a new one",
  untitledTemplate: "Untitled template",
  defaultSubject: "Email subject",
  copy: "Copy",
  duplicate: "Duplicate",
  delete: "Delete",
  subject: "Subject",
  subjectPlaceholder: "Enter email subject...",
  insertVariable: "Insert variable",
  mergeVariables: "Merge variables",
  variables: "Variables",
  edit: "Edit",
  preview: "Preview",
  previewMode: "Preview mode",
  previewHint: "Variables shown with sample values",
  catSystem: "System",
  catTransactional: "Transactional",
  catMarketing: "Marketing",
} as const;
export default emailDesigner;
